import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

export const AccountRiskAlert = () => {
  const { t } = useTranslation('global');
  return (
    <div className="flex flex-col gap-8 rounded-8 bg-background-primary-alert-default p-32 text-content-complementary">
      <span className="title-l">
        {t('overdueInvoice.closedDoor.risk.title')}
      </span>
      <p className="body-m">
        {t('overdueInvoice.closedDoor.risk.description')}
      </p>
    </div>
  );
};
